class Logger {
	
	static info (...msg) {
		console.log(...msg);
	}
	
	static error (...msg) {
		console.log(...msg);
	}
	
	static debug (...msg) {
		console.log(...msg);
	}
	
	static event (a, b) {
		console.log("event:", a, b);
	}
	
}

export default Logger;